export default __webpack_public_path__ + "static/media/Forms.5d270df4.svg";